const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export const groupDigits = (value: number): string => String(Math.round(value)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

export const pad2 = (value: number): string => String(value).padStart(2, '0')

const COUNT_WORDS = ['No', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve']

/**
 * A count written out for headlines ("Nine buildings"), falling back to digits above twelve.
 */
export const countWord = (value: number): string => COUNT_WORDS[value] ?? String(value)

/**
 * Month labels such as "Oct 24", starting from an ISO date (YYYY-MM or YYYY-MM-DD).
 */
export const monthLabels = (start: string, count: number): Array<string> => {
    const match = /^(\d{4})-(\d{2})/.exec(start)
    const year = match ? Number(match[1]) : 2024
    const month = match ? Number(match[2]) - 1 : 9

    return Array.from({ length: count }, (_, index) => {
        const total = month + index
        const y = year + Math.floor(total / 12)
        const m = ((total % 12) + 12) % 12

        return `${MONTHS[m]} ${String(y).slice(2)}`
    })
}

/**
 * Formats an ISO date as "2026.09.18" for mono readouts.
 */
export const formatDate = (iso: string): string => {
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso)

    if (!match) return iso

    return `${match[1]}.${match[2]}.${match[3]}`
}

/**
 * Projects without a bespoke point cloud get a massing model seeded by their slug.
 */
export const shapeKey = (shape: string, slug: string): string => {
    const known = ['library', 'housing', 'hall', 'archive', 'bathhouse', 'pavilion', 'station']

    return known.includes(shape) ? shape : `generic:${slug}`
}

export const readingMinutes = (words: number): number => Math.max(1, Math.round(words / 220))

export const countWords = (text: string): number => text.trim().split(/\s+/).filter(Boolean).length
